import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { orderEventIdZodSchema } from "@@/shared/orders/order-events/events/_order-event-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { providerSlugZodSchema } from "@@/shared/providers/provider";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";

const payRequestReferencesZodObject = z.object({
    orderEventIds: orderEventIdZodSchema.array().min(1),
    orderGroupId: orderGroupIdZodSchema,
    orderId: orderIdZodSchema,
    providerId: providerIdZodSchema,
    providerSlug: providerSlugZodSchema.nullish(),
    orderGroupReference: z.string().optional(),
});

type PayRequestReferences = z.infer<typeof payRequestReferencesZodObject>;
const payRequestReferencesZodSchema: z.ZodSchema<PayRequestReferences> =
    payRequestReferencesZodObject;

export { payRequestReferencesZodObject, payRequestReferencesZodSchema };
export type { PayRequestReferences };
